import React, { useEffect, useState } from "react";
import firebase from "firebase";
import styled from "styled-components";
import SubHeader from "../components/SubHeader";
import useAuth from "../hooks/useAuth";
import Wrapper from "../components/Layout/Wrapper";
import StarCounter from "../components/StarCounter";

const ProfileWrapper = styled.div``;

const DEFAULT_PROFILE_IMAGE =
  "https://t4.ftcdn.net/jpg/03/46/93/61/360_F_346936114_RaxE6OQogebgAWTalE1myseY1Hbb5qPM.jpg";

const Profile = () => {
  const [imageUrl, setImageUrl] = useState(DEFAULT_PROFILE_IMAGE);
  const { accountDetails, isAdmin } = useAuth();

  useEffect(() => {
    if (accountDetails?.imageUrl) {
      firebase
        .storage()
        .ref(accountDetails.imageUrl)
        .getDownloadURL()
        .then(setImageUrl);
    }
  }, [accountDetails?.imageUrl]);

  const onImageChange = (
    imageName: string,
    nextImage: Blob,
    nextImageURI: string
  ) => {
    const imagePath = `user/${accountDetails?.id}/${imageName}`;
    firebase
      .storage()
      .ref(imagePath)
      .put(nextImage)
      .then(() => {
        firebase
          .firestore()
          .collection(isAdmin ? "administrators" : "students")
          .doc(accountDetails?.id)
          .update({ imageUrl: imagePath });
        setImageUrl(nextImageURI);
      });
  };

  return (
    <ProfileWrapper>
      <SubHeader
        title={accountDetails?.name || "..."}
        subtitle={isAdmin ? "Admin" : "Student"}
        imageUrl={imageUrl}
        onImageChange={onImageChange}
      />
      <Wrapper style={{ marginTop: 32 }}>
        {!isAdmin ? (
          <div>
            <h2>Awards</h2>
            {(accountDetails?.awards || []).map((award) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <hgroup style={{ marginRight: 60 }}>
                  <h3>{award.title}</h3>
                  <div>{award.description}</div>
                </hgroup>
                <StarCounter stars={award.stars} />
              </div>
            ))}
          </div>
        ) : (
          <div>
            <p>Taecher profile view coming soon</p>
          </div>
        )}
      </Wrapper>
    </ProfileWrapper>
  );
};

export default Profile;
